<div class="mobile-project-container" *transloco="let t">
  <div class="content" [ngClass]="selectedCampaignView == MobileCampaignsViewOptions.MAP ? 'map' : 'list'">
    <div class="header-wrapper">

      <div class="header-container">
        <div class="total-promo-amount" (click)="openRewardListSlideIn()">
          ${{ userRewardsSum | moneyFormat }}
        </div>
        <div class="detailed-filters">
          <div class="map-list-container">
            <img ngSrc="assets/icons/list-icon.svg" (click)="switchView(campaignsView.LIST)"
                 [ngClass]="{selected: selectedCampaignView == campaignsView.LIST}" alt="list-icon" height="16"
                 width="17">
            <img ngSrc="assets/icons/map-icon.svg"
                 (click)="selectedPlacesLoyaltyStatus !== LoyaltyScreen.BOUNTIES && switchView(campaignsView.MAP)"
                 [ngClass]="{selected: selectedCampaignView == campaignsView.MAP, disabled: selectedPlacesLoyaltyStatus === LoyaltyScreen.BOUNTIES}"
                 alt="list-icon" height="16"
                 width="17">
          </div>
          <button mat-stroked-button class="button-small"
                  [disabled]="selectedPlacesLoyaltyStatus === LoyaltyScreen.BOUNTIES"
                  (click)="openFilterBottomSlideIn()">
            {{ t('navbar.filter') }}
          </button>
        </div>
      </div>

      @if (selectedCampaignView == MobileCampaignsViewOptions.LIST) {
        <mat-divider></mat-divider>
        <div class="buttons-container">
          <div class="search-button">
            <mat-icon svgIcon="magnifying-glass"></mat-icon>
          </div>
          <div class="chip-button"
               [class.selected]="selectedPlacesLoyaltyStatus === LoyaltyScreen.WITH_LOYALTY"
               (click)="filterByUserStatus(LoyaltyScreen.WITH_LOYALTY)">
            {{ t('navbar.myPlaces') }}
          </div>
          <div class="chip-button"
               [class.selected]="selectedPlacesLoyaltyStatus === LoyaltyScreen.WITHOUT_LOYALTY"
               (click)="filterByUserStatus(LoyaltyScreen.WITHOUT_LOYALTY)">
            {{ t('navbar.discover') }}
          </div>
          <div class="chip-button"
               [class.selected]="selectedPlacesLoyaltyStatus === LoyaltyScreen.BOUNTIES",
               (click)="filterByUserStatus(LoyaltyScreen.BOUNTIES)">
            {{ t('navbar.bounties') }}
          </div>
        </div>
      }
    </div>
    @if (isUserOnboardingDisplayed === false || !isUserTransactionHistoryLoaded) {
      <div class="onboarding-dialogs">
        <app-places-with-benefits [loaded]="isUserTransactionHistoryLoaded"></app-places-with-benefits>
      </div>
    } @else if (isUserOnboardingDisplayed === true) {
      @if (selectedCampaignView == MobileCampaignsViewOptions.LIST) {
        @if (selectedPlacesLoyaltyStatus == LoyaltyScreen.WITH_LOYALTY) {
          <div class="campaigns-list-container">
            <app-my-places-screen></app-my-places-screen>
          </div>
        } @else if(selectedPlacesLoyaltyStatus == LoyaltyScreen.WITHOUT_LOYALTY) {
          <div class="campaigns-list-container">
            <app-campaign-without-loyalty-list></app-campaign-without-loyalty-list>
          </div>
        } @else if(selectedPlacesLoyaltyStatus == LoyaltyScreen.BOUNTIES) {
          <div class="campaigns-list-container">
            <app-ghost-merchant-bounty-list></app-ghost-merchant-bounty-list>
          </div>
        }
      } @else {
        <div class="map-container">
          @if (selectedPlacesLoyaltyStatus == LoyaltyScreen.WITH_LOYALTY) {
            <app-locations-with-loyalty-map [filterStore]="filterStore"></app-locations-with-loyalty-map>
          } @else {
            <app-locations-without-loyalty-map [filterStore]="filterStore"></app-locations-without-loyalty-map>
          }
        </div>
      }
    }
  </div>
</div>
